import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { colors, Button } from 'react-orange-ui';

import WordingService from '../../../services/WordingService';

import {
  Container, Actions, Details, Banner, BannerDetail, BannerType,
} from './BaseBanner';

/**
 * Client error banner component
 */
class ErrorClient extends Component {
  handleCopy = () => {
    const { error, handleCopy } = this.props;
    handleCopy(JSON.stringify(error));
  };

  render() {
    const {
      handleClick, handleClose, collapse, pathname, error,
    } = this.props;

    return (
      <Container id="error-banner">
        <Banner id="error-banner__resume" onClick={handleClick} background={colors.supportingLighterGold}>
          <BannerType icon="Warning-important" color={colors.orange2} title="errorClient" />
          <BannerDetail label="Message" content={error.message} />
        </Banner>
        <Details id="error-banner__details" collapse={collapse} borderColor={colors.supportingLighterGold}>
          <BannerDetail label="Page" content={pathname} />
          <BannerDetail label="User Agent" content={error.userAgent} />
          <div>
            <BannerDetail label="Stack trace" content={error.stack} raw />
            <Button size="s" onClick={this.handleCopy}>
              {WordingService.getWording('button', 'copy')}
            </Button>
          </div>
        </Details>
        <Actions id="error-banner__actions">
          <Button id="close-banner-action" type="icon" size="s" icon="delete" onClick={handleClose} />
        </Actions>
      </Container>
    );
  }
}

ErrorClient.propTypes = {
  /** Boolean when banner is collapse */
  collapse: PropTypes.bool.isRequired,
  /** Object error */
  error: PropTypes.shape().isRequired,
  /** String actual route pathname */
  pathname: PropTypes.string.isRequired,
  /** Function callback */
  handleClick: PropTypes.func.isRequired,
  /** Function callback */
  handleClose: PropTypes.func.isRequired,
  /** Function callback */
  handleCopy: PropTypes.func.isRequired,
};

export default ErrorClient;
